import axios from 'axios'

export default {
  get() {
    return axios.get('/timer').then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  start() {
    return axios.post('/timer/start').then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  stop() {
    return axios.post('/timer/stop').then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  reset() {
    return axios.post('/timer/reset').then(response => {
      return { success: true }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  }
}
